import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const NotFoundPage: React.FC = () => {
  useEffect(() => {
    document.title = "LinkPlease - 404 Not Found";
  }, [])
  return (
    <div 
      className="min-h-screen w-full flex items-center justify-center bg-cover bg-center bg-no-repeat bg-fixed"
      style={{
        backgroundImage: 'url("https://www.app.linkplease.co/assests/bg.svg")',
        backgroundSize: 'cover',
        backgroundAttachment: 'fixed',
        minHeight: '100vh',
        width: '100%'
      }}
    >
      <div className="">
        <div className="text-center">
          <h1 className="text-[4rem] font-bold text-[#7772FF] mb-2">404</h1>
          <p className="text-xl font-medium text-gray-800 mb-8">
            Oops! Page not found
          </p>
          
          <Link 
            to="/" 
            className="inline-block bg-[#7772FF] text-white px-8 py-3 rounded-lg font-medium hover:bg-[#6561FF] transition-colors"
          >
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
